export default __webpack_public_path__ + "static/media/sapiens(1).bb068458.png";